import React from "react";
import { createStore } from "@methodjs/store";

interface DisplayModalState {
  open: boolean;
  ModalComponent: JSX.Element;
}

export const DefaultModal = () => {
  return <>기본 모달 상태입니다.</>;
};

export const initDisplayModalState = (): DisplayModalState => ({
  open: false,
  ModalComponent: <DefaultModal />,
});

const [useDisplayModalStore, setDisplayModalStore, getDisplayModalStore] =
  createStore(initDisplayModalState);

export { useDisplayModalStore, setDisplayModalStore, getDisplayModalStore };
